import { Injectable } from '@angular/core'
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router'
import { catchError, map, Observable, of, tap } from 'rxjs'
import { AuthApiService } from '../services/auth-api.service'
import { ROUTER_STATE_KEY_PREVENT_LOGIN_REDIRECT } from '../constants/router-state-keys'
import { QUERY_PARAM_KEY_RETURN_URL } from '../constants/query-params-keys'
import { Store } from '@ngrx/store'
import { userActions } from '../../state/user/user.actions'

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(
        private readonly authApi: AuthApiService,
        private readonly router: Router,
        private readonly store: Store
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Hack: CanActivate interface expects both params and compiler expects them to be used
        route

        return this.authApi.getUsername().pipe(
            tap((userName: string) =>
                this.store.dispatch(userActions.usernameLoaded({ userName }))
            ),
            map(() => true),
            catchError(() => {
                this.router.navigate(['/login'], {
                    queryParams: { [QUERY_PARAM_KEY_RETURN_URL]: encodeURI(state.url) },
                    state: { [ROUTER_STATE_KEY_PREVENT_LOGIN_REDIRECT]: true },
                    skipLocationChange: true,
                })
                return of(false)
            })
        )
    }
}
